import * as fm from 'src/generated/api/fm.api';

type GetFile = fm.paths['/api/download/{uuid}']['get'];
export type GetFileParams = GetFile['parameters']['path']['uuid'];
export type GetFileResp = GetFile['responses']['200']['schema'];

type UploadFile = fm.paths['/api/upload']['post'];
export type UploadFileParams = UploadFile['parameters']['formData'];
export type UploadFileResp = UploadFile['responses']['200']['schema'];
